// src/supabase.js — Supabase client for Brandostro app
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ntvtkwxklvilbxkfhoew.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im50dnRrd3hrbHZpbGJ4a2Zob2V3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0NjIxMzIsImV4cCI6MjA5MzAzODEzMn0.1AA1siYdZprR9NA-6AaFR6t08IX69wjowDZvBknZu9k';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
